<template>
  <div class="mt-2">
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newBookEntryBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea un
                  nuovo Movimento Contabile cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewBookEntry"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea
                </b-button>
              </div>
            </template>
            <template v-else>
              <empty-table
              :isTableInModal="isTableInModal"
              :performedSearch="performedSearch"
              :automaticPerformedSearch="automaticPerformedSearch"
              :filterCount="filterCount"
            />
            </template>
          </template>
          <template #cell(additional_description)="{ item }">
            {{
              item?.payment_reference?.code
                ? `${item.payment_reference.code} - ${item.additional_description}`
                : item.additional_description
            }}
          </template>
          <template #cell(customer)="{ item }" v-if="items.length">
            <template v-if="item.registries.length">
              {{
                item.registries.length
                  ? item.registries[0].status_registry.value === 1
                    ? item.registries[0].attributables.CNAM
                    : item.registries[0].attributables.SURN +
                    " " +
                    item.registries[0].attributables.NAME
                  : ""
              }}
            </template>
            <template v-else-if="item.various_accountings.length">
              <template
                v-if="
                  item.various_accountings[0] != null &&
                  Object.prototype.hasOwnProperty.call(
                    item.various_accountings[0],
                    'pivot'
                  ) &&
                  item.various_accountings[0].pivot != null &&
                  Object.prototype.hasOwnProperty.call(
                    item.various_accountings[0].pivot,
                    'registry_title'
                  )
                "
              >
                <span data-fallback="true">{{
                    item.various_accountings[0].pivot.registry_title
                  }}</span>
              </template>
            </template>
          </template>
          <template #cell(gross_coass)="{ item }" v-if="items.length">
            <span
              v-if="!item.insurance_ancillaries[0]?.insurer_participants.length"
            >
              No
            </span>
            <span
              v-for="(insurer_participant, index) in item
                .insurance_ancillaries[0]?.insurer_participants"
              :key="index"
            >
              {{
                insurer_participant.code +
                "-" +
                insurer_participant.title +
                ": " +
                toLocaleCurrency(insurer_participant.pivot.gross)
              }}<br/>
            </span>
          </template>
          <template #cell(insurer_description)="{ item }" v-if="items.length">
            <span>
              {{
                item.insurer ? `${item.insurer.code}-${item.insurer.title}` : ""
              }}
            </span>
          </template>
          <template #cell(document_code)="{ item }" v-if="items.length">
            <span v-for="(book_tag, index) in item.book_tags" :key="index">
              {{ `${book_tag.code}` }}
            </span>
          </template>
          <template #cell(take)="{ item }" v-if="items.length">
            {{ taking(item) }}
          </template>
          <template #cell(title)="{ item }" v-if="items.length">
            {{
              (item.title ? item.title : "") +
              (item?.registries?.[0]?.title
                ? ` - ${item.registries[0].title}`
                : "")
            }}
          </template>
          <template
            #cell(insurance_policy_number)="{ item }"
            v-if="items.length"
          >
            {{
              item.various_accountings && item.various_accountings.length
                ? item.various_accountings[0].pivot.insurance_policy_number
                : item.insurance_ancillaries &&
                item.insurance_ancillaries.length
                  ? item.insurance_ancillaries[0].insurance_policy
                    ? item.insurance_ancillaries[0].insurance_policy.number
                    : ""
                  : ""
            }}
          </template>
          <template #cell(branch)="{ item }" v-if="items.length">
            {{
              item.insurance_ancillaries && item.insurance_ancillaries.length
                ? item.insurance_ancillaries[0].insurance_policy
                  ? item.insurance_ancillaries[0].insurance_policy
                    .insurance_risk
                    ? `${item.insurance_ancillaries[0].insurance_policy.insurance_risk.risk_branch.code}-${item.insurance_ancillaries[0].insurance_policy.insurance_risk.code}-
                    ${item.insurance_ancillaries[0].insurance_policy.insurance_risk.risk_branch.formatted_title}`
                    : ""
                  : ""
                : item.various_accountings && item.various_accountings.length
                  ? item.various_accountings[0].pivot.insurance_risk
                    ? `${item.various_accountings[0].pivot.insurance_risk.risk_branch.code}-${item.various_accountings[0].pivot.insurance_risk.code}-
                  ${item.various_accountings[0].pivot.insurance_risk.risk_branch.formatted_title}
                  `
                    : ""
                  : ""
            }}
          </template>
          <template #cell(product)="{ item }" v-if="items.length">
            <span>{{
              item.insurance_ancillaries && item.insurance_ancillaries.length
                ? item.insurance_ancillaries[0].insurance_policy &&
                item.insurance_ancillaries[0].insurance_policy.insurance_risk
                  ? item.insurance_ancillaries[0].insurance_policy
                    .insurance_risk.formatted_title
                  : ""
                : item.various_accountings && item.various_accountings.length
                  ? item.various_accountings[0].pivot.insurance_risk
                    ? item.various_accountings[0].pivot.insurance_risk
                      .formatted_title
                    : ""
                  : ""
            }}</span>
          </template>
          <template #cell(prodotto_incassi)="{ item }" v-if="items.length">
            <span
              v-if="
                item.insurance_ancillaries &&
                item.insurance_ancillaries.length &&
                item.insurance_ancillaries[0].insurance_policy
              "
            >
              {{
                getRiskTypeDescription(
                  item.insurance_ancillaries[0].insurance_policy,
                )
              }}
            </span>
            <template v-else> - </template>
          </template>
          <template #cell(saler_gross)="{ item }" v-if="items.length">
            {{
              toLocaleCurrency(item.saler_prov_purchase + item.saler_prov_take)
            }}
          </template>
          <template #cell(agency_gross)="{ item }" v-if="items.length">
            {{
              toLocaleCurrency(
                item.agency_prov_purchase + item.agency_prov_take
              )
            }}
          </template>
          <template #cell(note)="{ item }" v-if="items.length">
            {{
              item.tasks.length
                ? item.tasks.filter((task) => task.task_type.value === 2 && task.context !== 'deferred').length
                : 0
            }}
          </template>
          <template #cell(document)="{ item }" v-if="items.length">
            {{ item.documents.length ? item.documents.length : 0 }}
          </template>
          <template #cell(note_counter)="row" v-if="items.length">
            <div
              role="button"
              class="info-box float-left"
              @click="customOpenNoteModal(row.item, row.index, $event.target)"
              v-b-tooltip="
                toTooltipTask(
                  row.item.tasks.filter((task) => task.task_type.value === 2 && task.context !== 'deferred'),
                  'Note',
                  [
                    { label: 'Titolo', key: 'title' },
                    { label: 'Descrizione', key: 'description' },
                    {
                      label: 'Ultimo aggiornamento',
                      key: 'last_update',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                    {
                      label: 'Creato da',
                      key: 'owner_id',
                      formatter: (val) => retriveOwner(val),
                    },
                    {
                      label: 'Data creazione',
                      key: 'created_at',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                  ]
                )
              "
            >
              {{
                row.item.tasks.filter((task) => task.task_type.value === 2 && task.context !== 'deferred')
                  .length
              }}
            </div>
          </template>
          <template #cell(deferred)="{ item }" v-if="items.length">
            <div>
              <b-icon
                v-if="totalDeferred(item.entry_details)"
                icon="exclamation-circle-fill"
                variant="danger"
              ></b-icon>
            </div>
          </template>
          <template #cell(document_counter)="row" v-if="items.length">
            <div
              role="button"
              class="info-box float-left"
              @click="customOpenDocModal(row.item, row.index, $event.target)"
              v-b-tooltip="
                toTooltipTask(row.item.documents, 'Documenti', [
                  { label: 'Titoli', key: 'title' },
                  { label: 'Descrizione', key: 'note' },
                  { label: 'Ultimo aggiornamento', key: 'last_update' },
                ])
              "
            >
              {{ row.item.documents.length }}
            </div>
          </template>
          <template #cell(cooperator)="{ item }" v-if="items.length">
            <span
              v-html="
                toInfoData(
                  item.brokers.find((e) => e.status_broker.value === 1),
                  'broker',
                  1
                )
              "
            ></span>
          </template>
          <template #cell(broker)="row" v-if="items.length">
            <b-row class="broker-cell"><span
              v-html="
                toInfoData(
                  row.item.brokers.find((e) => e.status_broker.value === 0),
                  'broker',
                  0
                )
              "
            ></span>
              <div class="action-buttons">
                <b-button
                  v-if="actions.includes('edit') || actions.includes('edit_broker')"
                  size="sm"
                  variant="lisaweb"
                  @click="onEdit(row.item, true)"
                  class="mt-1 ml-3"
                  title="Modifica Produttore"
                  :disabled="hasBrokerStatement(row.item)"
                >
                  <base-icon name="edit" width="22"></base-icon>
                </b-button>
              </div>
            </b-row>
          </template>
          <template #cell(entry_in)="{ item }" v-if="items.length">
            {{ toLocaleCurrency(pos_entry(item, dbRowData.code)) }}
          </template>
          <template #cell(entry_out)="{ item }" v-if="items.length">
            {{ toLocaleCurrency(Math.abs(neg_entry(item, dbRowData.code))) }}
          </template>
          <template #cell(pos_rebate)="{ item }" v-if="items.length">
            {{ toLocaleCurrency(pos_entry(item, "AB")) }}
          </template>
          <template #cell(neg_rebate)="{ item }" v-if="items.length">
            {{ toLocaleCurrency(neg_entry(item, "AB")) }}
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item, false)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>
              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                :disabled="
                  isImported(row.item) ||
                  isInsurerAccounting(row.item) ||
                  hasBrokerStatement(row.item)
                "
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22"></base-icon>
              </b-button>
            </div>
          </template>

          <template
            slot="thead-top"
            slot-scope="data"
            v-if="Object.keys(dbRowData).length && items.length"
          >
            <td v-for="(field, i) in data.fields" :key="i" class="totalRow">
              <b
              >{{ i == 0 && field.key === "book_date" ? "" : "" }}
                {{
                  i !== 0 && field.key === "additional_description"
                    ? checkBalanceLabelbyDate
                    : ""
                }}
                {{
                  i !== 0 && field.key === "entry_in"
                    ? `${checkBalancebyDate("in")}`
                    : null
                }}
                {{
                  i !== 0 && field.key === "entry_out"
                    ? `${checkBalancebyDate("out")}`
                    : null
                }}
              </b>
            </td>
          </template>
          <template
            slot="bottom-row"
            v-if="Object.keys(dbRowData).length && items.length"
          >
            <td colspan="4">
              <div class="row pagination--intable">
                <div class="show-text">
                  <p>Mostra</p>
                </div>
                <div class="group">
                  <b-form-group
                    label-for="per-page-select"
                    label-cols-sm="3"
                    label-cols-md=""
                    label-cols-lg="3"
                    label-size="sm"
                    md="auto"
                  >
                    <b-form-select
                      id="per-page-select"
                      v-model="perPage"
                      :options="pageOptions"
                      style="width: 68px"
                      size="sm"
                      @change="onPageChange(1)"
                      :disabled="!items.length"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="page">
                  <p>di {{ totalItems }} per pagina</p>
                </div>
                <div class="pagination" v-if="totalItems">
                  <b-pagination
                    v-model="currentPage"
                    limit="3"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    size="sm"
                    @change="onPageChange"
                  ></b-pagination>
                </div>
                <div
                  class="input_pagination"
                  v-if="totalItems && !noInputPaginator && totalPages > 3"
                >
                  <base-input-pagination
                    @pagination="onInputPagination"
                  ></base-input-pagination>
                </div>
              </div>
            </td>
          </template>
          <template slot="custom-foot" slot-scope="data">
            <template v-if="includeBottomRow && items.length">
              <td
                v-for="(field, i) in data.fields"
                :key="i"
                class="totalRow totalRow--upper-pagination"
              >
                <b
                >{{ i === 0 ? "Totale: " : "" }}
                  {{
                    i !== 0 && field.key === "gross"
                      ? toLocaleCurrency(fieldSum(items, "gross"))
                      : null
                  }}
                  {{
                    i !== 0 && field.key === "agency_gross"
                      ? toLocaleCurrency(
                        fieldSum(items, "agency_prov_take") +
                        fieldSum(items, "agency_prov_purchase")
                      )
                      : null
                  }}
                  {{
                    i !== 0 && field.key === "saler_gross"
                      ? toLocaleCurrency(
                        fieldSum(items, "saler_prov_take") +
                        fieldSum(items, "saler_prov_purchase")
                      )
                      : null
                  }}
                </b>
              </td>
            </template>
            <template v-if="Object.keys(dbRowData).length && items.length">
              <td
                v-for="(field, i) in data.fields"
                :key="i"
                class="totalRow totalRow--upper-pagination"
              >
                <span
                  v-if="i !== 0 && field.key === 'additional_description'"
                  class="info"
                  v-html="
                    `Totale Movimenti<br><b>${checkFinalBalanceLabel}</b>`
                  "
                >
                </span>
                <span
                  v-if="i !== 0 && field.key === 'entry_in'"
                  class="info"
                  v-html="
                    `${toLocaleCurrency(
                      dbRowData.entry_in
                    )}<br><b>${checkFinalBalance('in')}</b>`
                  "
                >
                </span>
                <span
                  v-if="i !== 0 && field.key === 'entry_out'"
                  class="info"
                  v-html="
                    `${toLocaleCurrency(
                      Math.abs(dbRowData.entry_out)
                    )}<br><b>${checkFinalBalance('out')}</b>`
                  "
                >
                </span>
              </td>
            </template>
            <template v-if="Object.keys(extraFooter).length && items.length">
              <td v-for="(field, i) in data.fields" :key="i" class="totalRow">
                <span
                  v-if="i !== 0 && field.key === 'additional_description'"
                  class="info"
                  v-html="`Totale Movimenti<br>${checkFinalBalanceLabel}`"
                >
                </span>
                <span
                  v-if="i !== 0 && field.key === 'pos_rebate'"
                  v-html="
                    `${
                      toLocaleCurrency(extraFooter.entry_in) +
                      '<br>' +
                      (extraFooter.entry_in + extraFooter.entry_out > 0
                        ? toLocaleCurrency(
                            extraFooter.entry_in + extraFooter.entry_out
                          )
                        : '')
                    }`
                  "
                >
                </span>
                <span
                  v-if="i !== 0 && field.key === 'neg_rebate'"
                  class="info"
                  v-html="
                  `${
                 toLocaleCurrency(extraFooter.entry_out) +
                        '<br>' +
                        (extraFooter.entry_in + extraFooter.entry_out   &lt; 0
                          ? toLocaleCurrency(
                              extraFooter.entry_in + extraFooter.entry_out
                            )
                          : '')
                  }`
                "
                >
                </span>
              </td>
            </template>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
              </template>
              <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>

      <b-modal
        :id="infomodalName"
        @show="onModalShow"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-title="Chiudi"
        ok-variant="-transparent"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14"/>
        </template>
        <div>
          <b-tabs content-class="" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>

              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="updatedData()"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import General from "@/components/accounting/book-entries/details/General.vue";
import Appointments from "@/components/accounting/book-entries/details/Appointments";
import Todo from "@/components/accounting/book-entries/details/Todo";
import Notes from "@/components/accounting/book-entries/details/Notes";
import {toLocaleCurrency} from "@/utils/strings";
import BaseInputPagination from "@/components/form/BaseInputPagination";
import Documents from "@/components/accounting/book-entries/details/Documents";
import {toLocaleDate} from "@/utils/dates";
import {mapGetters} from "vuex";
import moment from "moment";
import {getRiskTypeDescription} from "../../utils/payments";
import EmptyTable from "@/components/EmptyTable.vue";

moment.locale("it");

export default {
  name: "BookEntriesTable",
  extends: template,
  data() {
    return {
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      tabs: [
        {name: "General", text: "Generale"},
        {name: "Appointments", text: "Appuntamenti"},
        {name: "Notes", text: "Note"},
        {name: "Todo", text: "Attività"},
        {name: "Documents", text: "Doc"},
      ],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
    };
  },
  components: {
    BaseIcon,
    General,
    Appointments,
    Todo,
    Notes,
    ButtonGroupTab,
    BaseInputPagination,
    Documents,
    EmptyTable
  },
  methods: {
    getRiskTypeDescription,
    moment,
    toLocaleCurrency,
    toLocaleDate,
    freeSearch() {
      this.$emit("manualFetch");
    },
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({name: "General", text: "Generale"}, 0);
    },
    onAddNewBookEntry() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    customOpenNoteModal(item, index, target) {
      this.tabIndex = 2; // TabIndex ID delle Note
      this.openModal(item, index, target);
    },
    customOpenDocModal(item, index, target) {
      this.tabIndex = 4; // TabIndex ID dei Documenti
      this.openModal(item, index, target);
    },
    updatedData() {
      this.fetch();
    },
    pos_entry(item, code) {
      if (item.entry_details) {
        // siamo nei book_entry
        let sector_id = this.$store.state.auth.sectors.find(
          (e) => e.code === code
        ).id;
        let treasury_codes_of_sector = this.$store.state.auth.treasuries
          .filter((e) => e.sector_id === sector_id)
          .map((e) => e.code);

        const entry = item.entry_details?.filter(
          (e) =>
            treasury_codes_of_sector.includes(e.treasury?.code) && e.gross > 0
        );
        return entry?.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.gross;
        }, 0);
      } else {
        // siamo nei agency_book
        return item.gross > 0 ? item.gross : 0;
      }
    },
    neg_entry(item, code) {
      if (item.entry_details) {
        // siamo nei book_entry
        let sector_id = this.$store.state.auth.sectors.find(
          (e) => e.code === code
        ).id;
        let treasury_codes_of_sector = this.$store.state.auth.treasuries
          .filter((e) => e.sector_id === sector_id)
          .map((e) => e.code);

        const entry = item.entry_details?.filter(
          (e) =>
            treasury_codes_of_sector.includes(e.treasury?.code) && e.gross < 0
        );
        return entry?.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.gross;
        }, 0);
      } else {
        // siamo nei agency_book
        return item.gross < 0 ? item.gross : 0;
      }
    },
    isImported(item) {
      return item.imported_at ? true : false;
    },
    hasBrokerStatement(item) {
      return item.broker_statement_id ? true : false;
    },
    isInsurerAccounting(item) {
      return item?.insurer_accountings?.length > 0 ? true : false;
    },
    taking(item) {
      return item?.insurance_ancillaries[0]?.collaboration_type?.value === 0
        ? "Si"
        : "No";
    },
    fieldSum(items, field) {
      items;
      return items
        .map((item) => item[field])
        .reduce((prev, next) => prev + next, 0);
    },
    totalDeferred(data) {
      return parseFloat(
        data
          .filter((el) => el?.treasury?.code == "SS")
          .reduce(function (acc, obj) {
            return acc + obj.gross;
          }, 0)
          .toFixed(2)
      );
    },
    retriveOwner(value) {
      if (!value) return "-";
      return (
        this.getUsers().find((user) => user.value === value)?.username ?? "-"
      );
    },
    ...mapGetters("auth", {
      getUsers: "users",
    }),
  },
  props: {
    currentBalance: {
      type: Object,
      default() {
        return {};
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: String,
      default() {
        return null;
      },
    },
    endDate: {
      type: String,
      default() {
        return null;
      },
    },
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
    extraFooter: {
      type: Object,
      default() {
        return {};
      },
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    newBookEntryBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkStartDate() {
      return this.startDate
        ? !moment(this.startDate, "YYYY-MM-DD").isAfter(
          this.dbRowData?.initial_balance_date,
          "day"
        )
        : true;
    },
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    checkBalanceLabelbyDate() {
      return toLocaleDate(this.dbRowData.initial_balance_date) ===
      toLocaleDate(this.startDate)
        ? `Saldo Iniziale al ${toLocaleDate(moment(this.startDate))}`
        : !this.startDate
          ? ""
          : `Saldo al ${toLocaleDate(
            moment(this.startDate).subtract(1, "d").format("YYYY-MM-DD")
          )}`;
    },
    checkFinalBalanceLabel() {
      return this.endDate
        ? `Saldo Finale al ${toLocaleDate(moment(this.endDate))}`
        : "Saldo Finale";
    },
    checkBalancebyDate() {
      return (type) => {
        const final_balance = this.checkStartDate
          ? this.dbRowData.initial_balance
          : this.dbRowData.initial_balance +
          this.currentBalance.entry_in +
          this.currentBalance.entry_out;
        return (type === "in" && final_balance > 0) ||
        (type === "out" && final_balance < 0)
          ? toLocaleCurrency(Math.abs(final_balance))
          : "";
      };
    },
    checkFinalBalance() {
      return (type) => {
        const final_balance =
          this.dbRowData.initial_balance +
          this.dbRowData.entry_in +
          this.dbRowData.entry_out +
          this.currentBalance.entry_in +
          this.currentBalance.entry_out;
        return (type === "in" && final_balance > 0) ||
        (type === "out" && final_balance < 0)
          ? toLocaleCurrency(Math.abs(final_balance))
          : "";
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/table-mixins";

.info {
  text-align: right;
}

@include accounting-table-totals;

.b-table-bottom-row {
  .row {
    margin: 0;
    justify-content: center;
    align-items: center;

    * {
      margin: 0;
    }

    .group {
      width: auto;
    }

    .page {
      + .pagination {
        padding-left: 10px;
        margin-left: 0;
        border-left: 1px solid var(--gray-300);
        border-radius: 0;
      }
    }

    .pagination {
      width: auto;
    }
  }
}
</style>
